"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const StyledButton = exports.StyledButton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  minWidth: '200px',
  [theme.breakpoints.down('sm')]: {
    width: '100%'
  }
}));
